import React, { useState, useEffect } from "react";
import DataTable from "react-data-table-component";
import dayjs from "dayjs";
//import axios from 'axios';
import { Info } from "@material-ui/icons";
import Button from "components/CustomButtons/Button.jsx";
import { API_GET, API_POST } from "../../services/api.service";
import GridItem from "components/Grid/GridItem.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import Card from "components/Card/Card.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardBody from "components/Card/CardBody.jsx";
import GetAppOutlinedIcon from "@material-ui/icons/GetAppOutlined";
import Snackbar from "../../components/Snackbar/Snackbar";
import {
    Box,
    Chip,
    CircularProgress,
    Tooltip,
    IconButton
} from "@material-ui/core";
import RefreshIcon from "@material-ui/icons/Refresh";
import { Alert } from '@material-ui/lab';

import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import InfoBox from "../../components/InfoIcon/InfoIcon";
import CodeBox from "../../components/CodeBox";
import {formatJSON} from "../../services/Common";




function sliceString(str, c = 20) {
    if (!str) {
        return str;
    } else {
        return str.slice(0, c);
    }
}




function ApiLog(props) {
    const search = props.location && props.location.search;
    let typeParam = new URLSearchParams(search).get('type');
    let typeIdp = new URLSearchParams(search).get('id');

    const [type, setType] = useState(typeParam);
    const [typeId, setTypeId] = useState(typeIdp);
    const [open, setOpen] = useState(false);
    const { classes, user } = props;
    const [data, setData] = useState({});
    const [page, setPage] = useState(1);
    const [total, setTotal] = useState(0);
    const [skip, setSkip] = useState(0);
    const countPerPage = 10;
    const [SelectedStatus, setSelectedStatus] = useState([]);
    const [prospectId, setProspectId] = useState([]);
    const [apiProspect, setApiProspect] = useState(false);
    const urlParams = new URLSearchParams(props.location && props.location.search);
    const fid = urlParams.get("fid");
    const [notify, setNotify] = useState({
        open: false,
        message: null,
        color: "success",
    });

    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [retryingRecords, setRetryingRecords] = useState(new Set());

    const handleRetry = async (record) => {
        const recordId = record._id;
        
        // Add record to retrying set
        setRetryingRecords(prev => new Set([...prev, recordId]));
        
        try {
            const url = record.requestURL || record.url;
            const method = record.method;
            const requestBody = record.requestPayload;
            
            if (!url) {
                throw new Error('No URL found for retry');
            }
            
            let response;
            
            // Determine if it's a GET request (empty request body) or POST request
            if (!requestBody || Object.keys(requestBody).length === 0) {
                // GET request

                response = await API_POST("comm/CallAPI", {
                    url, ssl: true,
                  });
                
                  
            } else {
                // POST request
                response = await API_POST("comm/postRequest", {
                    url, ssl: true, body: requestBody
                  });
            }
            
            // Update the record in the database
            if(response && response.status){
                const updateRequest = await API_POST("action/update", {
                    root: type === 'integration' ? 'apiResponses' : 'APILogs',
                    body: {
                        responseData: {
                            ...response,
                            retried: true,
                            retryTime: new Date().toISOString()
                        }
                    },
                    querydata: { _id: recordId }
                });
                loadApiProspects();
            }
            /*

            */

            
        } catch (error) {
            console.error('Retry failed:', error);
            setNotify({
                open: true,
                message: `Retry failed: ${error.message}`,
                color: "danger"
            });
        } finally {
            // Remove record from retrying set
            setRetryingRecords(prev => {
                const newSet = new Set(prev);
                newSet.delete(recordId);
                return newSet;
            });
        }
    };

    const columns = [
        {
            name: "URL",
            sortable: true,
            width: "250px",
            cell: (row) => (
                <Tooltip 
                    title={row.requestURL || 'No URL'}
                    placement="top-start"
                    enterDelay={500}
                >
                    <div>
                        <CodeBox 
                            content={row.requestURL} 
                            maxHeight="50px"
                            type="url"
                        />
                    </div>
                </Tooltip>
            ),
        },
        {
            name: "Source",
            sortable: true,
            width: "120px",
            cell: (row) => (
                <Chip 
                    label={row.method} 
                    color="default" 
                    size="small"
                    style={{
                        backgroundColor: row.method === 'POST' ? '#e3f2fd' : 
                                       row.method === 'GET' ? '#e8f5e9' : '#fafafa'
                    }}
                />
            ),
        },
        {
            name: "Status",
            width: "120px",
            sortable: true,
            cell: (row) => {
                const allowed = ["success", "200","success"];
                const dataString = row.responseData && typeof row.responseData === 'object' ? JSON.stringify(row.responseData).toLowerCase() : '';
                //alert(dataString);
                const isFailed = !(row.responseData && row.responseData && typeof row.responseData === 'object' && allowed.some(text => new RegExp(`\\b${text}\\b`, "i").test(dataString)));
                
                return (<span>{ !isFailed ? 'Success' : 'Failed'}</span>);
            },
        },
        {
            name: "Request Body",
            width: "300px",
            sortable: true,
            cell: (row) => {
                const payload = row.requestPayload;
                const isValidPayload = payload !== null && payload !== undefined;

                return (
                    <Tooltip 
                        title={isValidPayload ? formatJSON(payload) : 'No request body'}
                        placement="top"
                        enterDelay={500}
                    >
                        <div>
                            <CodeBox 
                                content={payload}
                                type="request"
                            />
                        </div>
                    </Tooltip>
                );
            },
        },
        {
            name: "Response",
            width: "300px",
            sortable: true,
            cell: (row) => {
                const response = row.responseData;
                const isError = response && (response.error || response.status === 'error');

                return (
                    <Tooltip 
                        title={response ? formatJSON(response) : 'No response data'}
                        placement="top"
                        enterDelay={500}
                    >
                        <div>
                            <CodeBox 
                                content={response}
                                maxHeight="200px"
                                type="response"
                                style={isError ? { borderColor: '#ff5252' } : {}}
                            />
                        </div>
                    </Tooltip>
                );
            },
        },
        {
            name: "Created On",
            width: "150px",
            sortable: true,
            cell: (row) => (
                <span>{dayjs(row.requestTime).format("DD/MM/YYYY HH:mm")}</span>
            ),
        },
        {
            name: "Actions",
            width: "100px",
            cell: (row) => {
                const allowed = ["success", "200","success"];
                const dataString = row.responseData && typeof row.responseData === 'object' ? JSON.stringify(row.responseData).toLowerCase() : '';
                //alert(dataString);
                const isFailed = !(row.responseData && row.responseData && typeof row.responseData === 'object' && allowed.some(text => new RegExp(`\\b${text}\\b`, "i").test(dataString)));
                const isRetrying = retryingRecords.has(row._id);
                
                if (isRetrying) {
                    return (
                        <CircularProgress 
                            size={20} 
                            style={{ color: '#ff9800' }} 
                        />
                    );
                }
                
                return isFailed ? (
                    <Tooltip title="Retry Request">
                        <IconButton
                            size="small"
                            onClick={() => handleRetry(row)}
                            style={{ color: '#ff9800' }}
                        >
                            <RefreshIcon fontSize="small" />
                        </IconButton>
                    </Tooltip>
                ) : (
                    <span style={{ color: '#4caf50', fontSize: '12px' }}>Success</span>
                );
            },
        },
    ];

    const pageLoadquery = async () => {
        debugger;
        let con;

        try {

            const urlParam = new URLSearchParams(window.location.search);
            let search = urlParam.get("Search");

            if (!search) {
                if (fid) {
                    con = { ...con, fid };
                } else {
                    con = { ...con };
                }
            } else {
                if (search) {
                    search = JSON.parse(atob(search));
                }

                con = { ...search, admin: user && user.admin };

                //   if (user && ["field_exc", "agent"].indexOf(user.role) > -1) {
                //     con = { ...con, caller: user && user.username };
                //   }
            }
        } catch (e) {

        }

        return con;
    };

    const handleExportExcel = async (e) => {
        let downloadFile = await API_POST(`action/ExportExcel`, {
            querydata: { admin: user && user.admin, fid: fid ? fid : null },
            body: { admin: user.admin, user: user.username, page: "prospecthistory" },
        });
        if (downloadFile.status == 200) {
            setNotify({
                open: true,
                message: "File is in process,Please check in file section.",
                color: "success",
            });
        }
    };

    const getUserList = async () => {
        if (user && user.admin) {
            //let con = await pageLoadquery();
            let con = { admin: user && user.admin };

            if (fid) {
                con = { ...con, fid };
            } else {
                con = { ...con, InSystem: "API" };
            }

            if (SelectedStatus && SelectedStatus.updateStatus) {
                con = { ...con, updateStatus: SelectedStatus.updateStatus };
            }

            let res = await API_GET(
                `action/getProspectHistory?page=${page}&per_page=${countPerPage}&delay=1`,
                null,
                {
                    query: con,
                }
            );
            // debugger;
            setData(res.data);

            let d = [];
            for (let i = 0; i < res.data.data.length; i++) {
                d.push(res.data.data[i]._id);
            }
            setProspectId(d);

        }
    };

    const filterData = async (data) => {
        //handleUrl(data);
        setSelectedStatus(data);

    };

    //   const handleUrl = async (data) => {
    //     let query;
    //     query=data;
    //     let search = btoa(JSON.stringify(query));
    //     const { history } = props;

    //     history.push({
    //       pathname: `/admin/ProspectHistory?fid=${fid}`,
    //       search: `Search=${search}`,
    //     });
    //   };



    const loadApiProspects = async () => {
        setLoading(true);
        setError(null);
        try {
            let con = { 'admin': user && user.admin };
            if (fid) {
                con = { ...con, fid };
            }
            if (props.defaultQuery) {
                con = { ...con, ...props.defaultQuery };
            }

            const body = {
                limit: countPerPage,
                skip: skip,
                sort: { _id: -1 },
            };

            const root = type === 'integration' ? 'apiResponses' : 'APILogs';

            if (typeId) {
                con = { ...con, Iid: typeId };
                delete con.admin;
            }

            const res = await API_POST('action/getdata', { root, con, body });

            const formattedData = res.data.data.map((v) => ({
                ...v,
                requestURL: v.requestURL || v.url,
                method: v.method || v.integrationName,
                responseData: v.responseData || v.lead,
                requestTime: v.requestTime || v.createdOn
            }));

            setData({ ...res.data, data: formattedData });
            setTotal(res.data.rowCount);
        } catch (error) {
            console.error('Error loading API logs:', error);
            setError('Failed to load API logs');
            setNotify({
                open: true,
                message: "Failed to load API logs",
                color: "danger"
            });
        } finally {
            setLoading(false);
        }
    }

    const apiLog = (e) => {
        setApiProspect(true);
        loadApiProspects();
    };
    useEffect(() => {

        setSkip((page - 1) * 10);
        apiLog();
    }, [page, SelectedStatus]);

    return (
        <div className="App">

            <Snackbar
                place="tr"
                color={notify.color}
                message={notify.message}
                open={notify.open}
                closeNotification={() => setNotify({ open: false })}
                close
            />


            <GridContainer>
                {/*

          {
            apiProspect ?  <Tab label={"Api Logs"} onChange={apiLog} style={{background:'#455a64'}}></Tab>  :   <Tab label={"Api Logs"} onChange={apiLog}></Tab>
          }

*/}


                <GridItem xs={12} sm={12} md={12}>
                    <h3>
                        API Logs
                        <span style={{ float: "right", fontSize: "15px" }}>
                            <GridItem style={{ float: "left", marginTop: "10px" }}>
                                <InfoBox name={'Schedule.ApiLog'} />
                            </GridItem>
                            {["manager", "owner"].indexOf(user && user.role) > -1 && (

                                <Button
                                    size="sm"
                                    color="transparent"

                                    justIcon
                                    title="Export To Excel ( Inserted Prospect will not be downloaded )"
                                    onClick={() => {
                                        handleExportExcel();
                                    }}
                                >
                                    <GetAppOutlinedIcon style={{ fontSize: "25px" }} />
                                </Button>

                            )}
                        </span>
                    </h3>

                    <DataTable
                        columns={columns}
                        data={data.data || []}
                        progressPending={loading}
                        progressComponent={
                            <CircularProgress style={{ margin: '20px auto', display: 'block' }} />
                        }
                        highlightOnHover
                        pagination
                        paginationServer
                        paginationTotalRows={total}
                        paginationPerPage={countPerPage}
                        paginationComponentOptions={{
                            noRowsPerPage: true
                        }}
                        onChangePage={(page) => setPage(page)}
                        noDataComponent={
                            <div style={{ padding: '24px' }}>
                                {error || 'No API logs found'}
                            </div>
                        }
                        sortServer
                        onSort={(column, sortDirection) => {
                            // Implement server-side sorting here
                            console.log(column, sortDirection);
                        }}
                        responsive
                        dense
                    />
                </GridItem>
            </GridContainer>

        </div>
    );
}

export default ApiLog;
